import { lazy } from "react"

const PrereleaseUserPage$$__react__lazy__component = lazy(() => 
    import("./PrereleaseUserPage__original__module.mjs")
        .then(module => module.get_$$PrereleaseUserPage$$PrereleaseUserPage$$react__component$$1d3j7p2dffifi())
        .then(component => ({ default: component }))
)

export const get_$$PrereleaseUserPage$$PrereleaseUserPage$$react__component$$1d3j7p2dffifi = () => PrereleaseUserPage$$__react__lazy__component